/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
import { t } from 'i18next';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Loader from '../../shared-ui/Loader';
import LogoWithText from '../logoWithText';
import './paymentPendingPage.scss';

class PendingPage extends Component {
  constructor (props) {
    super(props);
    this.redirectHomeDetails = this.redirectHomeDetails.bind(this);
    this.state = {
      isLoading: true
    };
  }

  componentDidMount () {
    setTimeout(() => {
      this.setState({
        isLoading: false
      });
    }, 2000);
  }

  redirectHomeDetails () {
    const { history } = this.props;
    console.log(this.props);
    const houseId = localStorage.getItem('houseId');
    history.push(`/home-details?house-id=${houseId}`);
  }

  render () {
    const { count, isLoading } = this.state;

    return (
      <div className='pending_container'>
        <Loader
          isLoading={isLoading} />
        <div className='logo_wrapper'>
          <LogoWithText />
        </div>
        <div className='page_title'>{t('process_payments')}</div>
        <div className='page_sub_title'>{t('pending_screen_msg1')}</div>
        <div className='page_sub_title'>{t('pending_screen_msg2')}</div>
        <div className='yes_button'
          onClick={this.redirectHomeDetails}>
          {t('YES')}
        </div>
      </div>
    );
  }
}

export default withTranslation()(withRouter(PendingPage));
